import { AwsClient } from 'aws4fetch';
import { getUserAlias, getMidwayCredentials } from '../auth/midway';
import { getEnvironmentConfig } from '../configurations/config';

const MAIN_APP_ACCESS_LOCK = 'amzn1.bindle.resource.mq5tmrj7td6q6hjbtn5a';

export interface Team {
  groupId: string;
  groupType: string;
}

let cached: Promise<Team[]> | null = null;

const fetchTeams = async (): Promise<Team[]> => {
  const alias = await getUserAlias();
  const credentials = await getMidwayCredentials();
  const aws = new AwsClient({
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
    region: 'us-west-2',
    service: 'lambda',
  });

  const response = await aws.fetch(getEnvironmentConfig().brassLambdaUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      action: 'listLockMemberships',
      bindleLockId: MAIN_APP_ACCESS_LOCK,
      userAlias: alias,
    }),
  });

  if (!response.ok) {
    throw new Error(`listLockMemberships failed: ${response.status}`);
  }
  const data = await response.json();
  return Array.isArray(data.teams) ? data.teams : [];
};

export const listAccessibleTeams = async (): Promise<Team[]> => {
  if (!cached) {
    cached = fetchTeams().catch((err) => {
      cached = null;
      throw err;
    });
  }
  return cached;
};
